import './user_goals.css'

import { useEffect, useState } from 'react';
import { get, post } from '../../Services/api';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import axios from 'axios';
import yyyy_mm_dd_date_format from '../../Utility/yyyy_mm_dd_date_format';
import FullScreenOverlay from '../../Components/FullScreenOverlay/FullScreenOverlay';
import BeanButtonNext from '../../Components/Buttons/BeanButton/BeanButtonNext/BeanButtonNext';
import BeanButtonPrev from '../../Components/Buttons/BeanButton/BeanButtonPrev/BeanButtonPrev';

import logo_img from '../../resources/Logo.svg'

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormGroup, FormControlLabel, Checkbox, FormControl } from '@mui/material';
import dayjs from 'dayjs';
import PreparingMealPlan from '../../Components/PreparingMealPlan/PreparingMealPlan';
import { Tooltip } from 'react-tooltip';
import { FaCheck } from "react-icons/fa";
import { GrNext } from "react-icons/gr";
import LinearProgress from '@mui/material/LinearProgress';
import logout from '../../Utility/logout';


function UserGoals() {

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [nextButtonText, setNextButtonText] = useState("Next");
    const [nextButtonStatus, setNextButtonStatus] = useState(1);

    const { currentUser } = useAuth();
    const [error, setError] = useState('');
    const [consentGiven, setConsentGiven] = useState(false);
    const [userConfig, setUserConfig] = useState({});
    const p_today_date = yyyy_mm_dd_date_format({})

    const [unit, setUnit] = useState('imperial'); // State for unit (metric or imperial)
    const [feet, setFeet] = useState(userConfig['height'] ? Math.floor(userConfig[questions[currentQuestionIndex].name] / 30.48) : null);
    const [inches, setInches] = useState(userConfig['height'] ? Math.round((userConfig[questions[currentQuestionIndex].name] / 30.48 - feet) * 12) : null);



    // Handle unit change (imperial or metric)
    const handleUnitChange = (event) => {
        if (questions[currentQuestionIndex].name === 'weight') {
            convertWeight(userConfig['weight'], event.target.value)
        }
        setUnit(event.target.value);
    };


    // Function to update the height in centimeters based on feet and inches
    const updateHeightInCm = (newFeet, newInches) => {
        const heightInCm = newFeet * 30.48 + newInches * 2.54;
        updateConfigProperty(questions[currentQuestionIndex].name, Math.floor(heightInCm));
    };

    // Function to update the height in centimeters based on feet and inches
    const convertWeight = (givenWeight, toUnit) => {
        if (givenWeight) {
            let newWeight = givenWeight;
            if (toUnit !== userConfig['p_unit']) {
                if (toUnit === 'imperial') {
                    newWeight = newWeight * 2.20462
                    updateConfigProperty('p_unit', 'lbs');
                } else if (toUnit === 'metric') {
                    newWeight = newWeight * 0.453592
                    updateConfigProperty('weight', 'kg');
                }
            }
            updateConfigProperty('weight', Math.round(newWeight));
        } else {
            updateConfigProperty('weight', null);
            updateConfigProperty('p_unit', null);
        }
    };



    useEffect(() => {
        getQuestionsAndOptions()
    }, [])


    const handleConsent = (consent) => {
        if (consent) {
            fetchLocation();
        } else {
            setError('Location access denied by the user.');
            updateConfigProperty('country_code', 'US')
        }
        setConsentGiven(true);
    };

    const fetchLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, handleError);
        } else {
            setError('Geolocation is not supported by this browser.');
            updateConfigProperty('country_code', 'US')
        }
    };

    const success = async (position) => {
        const { latitude, longitude } = position.coords;

        try {
            const apiKey = 'AIzaSyDMhWcfIXesLV_CelgzO4-v--p37c57Pp4';
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
            );

            const results = response.data.results;
            const country = results.find((result) =>
                result.types.includes('country')
            );

            if (country) {
                const countryCode = country.address_components[0].short_name;
                updateConfigProperty('country_code', countryCode)
                if (countryCode !== 'US') {
                    setUnit('metric')
                }
            } else {
                setError('Unable to determine country code.');
                updateConfigProperty('country_code', 'US')
            }
        } catch (error) {
            setError('Error retrieving location data.');
            updateConfigProperty('country_code', 'US')
        }
    };

    const handleError = (error) => {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                setError('User denied the request for Geolocation.');
                break;
            case error.POSITION_UNAVAILABLE:
                setError('Location information is unavailable.');
                break;
            case error.TIMEOUT:
                setError('The request to get user location timed out.');
                break;
            case error.UNKNOWN_ERROR:
            default:
                setError('An unknown error occurred.');
                break;
        }
    };

    async function getQuestionsAndOptions() {
        const resp = await get("/api/user-config/get-questions-and-options")
        resp.map((q) => {
            // courses to eat, default breakfast, lunch, dinner
            if (q.id == 15) {
                userConfig[q.name] = q.options.map((course) => course.id)
            } else if (q.type === "checkbox") {
                userConfig[q.name] = []
            } else {
                userConfig[q.name] = ""

            }
        })

        setQuestions(resp)
    }

    async function nextQuestion() {
        var move = true

        if (questions[currentQuestionIndex].mandatory) {
            if (questions[currentQuestionIndex].type === "checkbox") {
                move = userConfig[questions[currentQuestionIndex].name].length !== 0 ? true : false
            } else {
                move = userConfig[questions[currentQuestionIndex].name] === "" ? false : true
            }
        }

        if (move) {

            if (currentQuestionIndex === questions.length - 1) {
                await create_user_config()
            } else {
                currentQuestionIndex === questions.length - 2 ? setNextButtonStatus(0) : setNextButtonStatus(1)
                setCurrentQuestionIndex(currentQuestionIndex < questions.length - 1 ? currentQuestionIndex + 1 : currentQuestionIndex)

            }
        } else {
            alert(`Your input for this field is required for us to provide the best service tailored to your needs. `)
        }
    }

    function lastQuestion() {
        currentQuestionIndex === questions.length ? setNextButtonStatus(0) : setNextButtonStatus(1)
        setCurrentQuestionIndex(currentQuestionIndex > 0 ? currentQuestionIndex - 1 : currentQuestionIndex)
    }

    async function create_user_config() {
        const newUserConfig = userConfig
        newUserConfig.uid = currentUser.uid
        try {
            const resp = await post('/api/user-config/create-user-config',
                { ...newUserConfig, p_today_date: p_today_date })
            if (resp.error === null) {

                // set 2 week meal plan
                document.getElementById('preparing_meal_plan').style.display = 'initial'
                const resp_meal_plan = await post('/api/meal-plan/generate-user-two-week-meal-plan', { user_id: currentUser.uid, current_date: p_today_date })

                document.getElementById('preparing_meal_plan').style.display = 'none'
                // reload page
                window.location.reload()
            } else {
                console.log(resp)
                alert("There was an error submitting user config, please submit again.")
            }
        } catch (e) {
            console.log(e)
            alert("There was an error submitting user config, please submit again.")
            // reload page
            window.location.reload()
        }
    }

    const handleCheckboxChange = (event, field) => {
        const { value, checked } = event.target;
        let updatedValues = [...userConfig[field]];

        if (checked) {
            updatedValues.push(value);
        } else {
            updatedValues = updatedValues.filter(item => item !== value);
        }

        updateConfigProperty(field, updatedValues)
    }

    const updateConfigProperty = (propertyName, newValue, question_id) => {
        let arr_option
        // Restrictions, cuisine
        if (questions[currentQuestionIndex].type === "checkbox") {
            arr_option = userConfig[propertyName] || []
            const index = arr_option.indexOf(newValue);
            if (index !== -1) {
                // Remove the value if it exists
                arr_option.splice(index, 1);
            } else {
                // Add the value if it doesn't exist
                arr_option.push(newValue);
            }
        }

        setUserConfig(prevConfig => ({
            ...prevConfig,
            [propertyName]: arr_option ? arr_option : newValue
        }));
    };

    function cuisineSelectedFunc(name, id) {
        if (questions[currentQuestionIndex].type === "checkbox") {
            const currentValues = userConfig[name] || [];
            return currentValues.includes(id);
        } else {
            const currentValues = userConfig[name];
            return currentValues == id;
        }
    }

    function capitalizeFirstLetter(text) {
        if (!text) return text; // Handle empty strings
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    function checkNextStatus() {
        var move
        const option = userConfig[questions[currentQuestionIndex].name]

        // Get today's date
        const today = new Date();
        // Calculate max and min dates
        const max_data = new Date();
        max_data.setFullYear(today.getFullYear() - 4);
        const min_date = new Date();
        min_date.setFullYear(today.getFullYear() - 120);

        console.log(option)
        console.log(questions[currentQuestionIndex])

        if (questions[currentQuestionIndex].type === "checkbox") {
            move = option.length !== 0 ? true : false
        } else if (questions[currentQuestionIndex].type === "date") {
            if (option && option != "" && option != "Invalid Date" && option < max_data.toISOString() && option > min_date.toISOString())
                move = true
            else move = false
        } else if (questions[currentQuestionIndex].id == 6 || questions[currentQuestionIndex].id == 9) {
            if (option && option != "" && option > 0)
                move = true
            else move = false
        } else {
            move = option === "" ? false : true
        }

        // not filled and manditory
        if (!move && questions[currentQuestionIndex].mandatory)
            return 'disable'
        // not filled and but skipable
        else if (!move && !questions[currentQuestionIndex].mandatory)
            return 'skip'
        // filled
        else
            return 'next'
    }

    return (
        <div>
            <div id='preparing_meal_plan'>
                <PreparingMealPlan />
            </div>

            {

                !consentGiven ? (
                    <FullScreenOverlay>
                        <div className='user_config_location_request_parent'>
                            <img src={logo_img} height={50} />

                            <p className='font_famil_ovo gray_scale_1 font_size_16 font_weight_400'>
                                This app needs access to your location to offer personalized settings.
                                We use your location to set default configurations like units and currency.
                                Rest assured, your location data will not be shared with third parties.
                                Do you allow us to use your location?
                            </p>
                            {/* green_outlined_button green_gradient_p font_size_14 font_family_inter font_weight_600' */}
                            <div className='user_config_location_request_buttons'>

                                <div className='user_config_next_button flex align_center gap_12' onClick={() => { handleConsent(true) }}>
                                    <p className='font_size_18'>Allow</p>
                                </div>
                                <div className='user_config_skip_button flex align_center gap_12' onClick={() => { handleConsent(false) }}>
                                    <p className='font_size_18'>Reject</p>
                                </div>
                            </div>

                        </div>
                    </FullScreenOverlay>
                ) :
                    (questions.length > 0 && <FullScreenOverlay>
                        <div className='user_config_parent_div font_family_inter'>
                            <div className='user_config_logout_div flex justify_center align_center' onClick={logout}>
                                <p>Logout</p>
                            </div>

                            <div className='flex justify_center'>
                                <img src={logo_img} height={50} />
                            </div>

                            <div className='user_config_main_div'>

                                <p className='green_1 font_weight_400 user_config_question text_align_center'>
                                    {
                                        questions[currentQuestionIndex].text
                                    }
                                </p>


                                {questions[currentQuestionIndex].id == 4 ?
                                    <div className='user_config_check_box_customized'>
                                        {questions[currentQuestionIndex].options.map((option) => (
                                            <div>
                                                {(
                                                    <div className={(cuisineSelectedFunc(questions[currentQuestionIndex].name, option.id) ? 'user_config_option_circle_selected' : 'user_config_option_circle') + ' flex align_center justify_center cursor_pointer'}
                                                        onClick={() => updateConfigProperty(questions[currentQuestionIndex].name, option.id, questions[currentQuestionIndex].id)}>
                                                        <p className='user_config_option_p'>{option.text} </p>
                                                    </div>)
                                                }
                                            </div>
                                        ))}
                                    </div>
                                    : questions[currentQuestionIndex].id == 13 ?
                                        <div className='user_config_asnwers_list gray_scale_1'>
                                            <FormControl>
                                                <div className='user_config_cuisine_div flex gap_40 flex_wrap'>
                                                    {questions[currentQuestionIndex].options.map((option) => (
                                                        <div className='text_align_center cursor_pointer' onClick={() => updateConfigProperty(questions[currentQuestionIndex].name, option.id, questions[currentQuestionIndex].id)}>
                                                            {cuisineSelectedFunc(questions[currentQuestionIndex].name, option.id) ? (<div className="user_config_cuisine_image_overlay_div">
                                                                <img src={option.text_2} className="user_config_cuisine_image" />
                                                                <div className="user_config_cuisine_image_overlay"></div>
                                                                <div className='user_config_cuisine_image_overlay_check'>
                                                                    <FaCheck color='#DAECE2' size={40} />
                                                                </div>
                                                            </div>)
                                                                : <img src={option.text_2} className="user_config_cuisine_image" />
                                                            }

                                                            <p className='user_config_option_p'>{option.text} </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </FormControl>
                                        </div>
                                        : (questions[currentQuestionIndex].type === "checkbox" || questions[currentQuestionIndex].type === "radio") ?
                                            <div className='user_config_check_box_customized'>
                                                {questions[currentQuestionIndex].options.map((option) => (
                                                    <div>
                                                        {(
                                                            <div className={(cuisineSelectedFunc(questions[currentQuestionIndex].name, option.id) ? 'user_config_option_oval_selected' : 'user_config_option_oval') + ' flex align_center justify_center cursor_pointer'}
                                                                onClick={() => updateConfigProperty(questions[currentQuestionIndex].name, option.id, questions[currentQuestionIndex].id)}>
                                                                <p className='user_config_option_p'>{option.text} </p>
                                                            </div>)
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                            : questions[currentQuestionIndex].type === "date" ?
                                                <div className='user_config_asnwers_list gray_scale_1'>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker label="Date of Birth" value={userConfig.dob ? dayjs(userConfig.dob) : null}
                                                            onChange={(newDate) => {
                                                                updateConfigProperty(questions[currentQuestionIndex].name, newDate?.format('YYYY-MM-DD'))
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            renderInput={(params) => (
                                                                <TextField

                                                                    {...params}
                                                                    InputProps={{
                                                                        ...params.InputProps,
                                                                        endAdornment: null, // Hide the calendar icon
                                                                    }}
                                                                />
                                                            )}
                                                            sx={{
                                                                '& .MuiInputLabel-root': {
                                                                    color: 'gray',
                                                                    '&.Mui-focused': {
                                                                        color: '#1F2933',
                                                                    },
                                                                },
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: '#82BD9C', // Default border color
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: '#299257', // Border color on hover
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: '#299257', // Border color when focused
                                                                    },
                                                                },
                                                            }}
                                                            disableFuture
                                                        />


                                                    </LocalizationProvider>
                                                </div>
                                                : questions[currentQuestionIndex].type === "select" ?
                                                    <div className='user_config_select_width'>
                                                        <FormControl fullWidth>
                                                            <InputLabel
                                                                sx={{

                                                                    '&.Mui-focused': {
                                                                        color: '#1F2933', // Color when the input is focused
                                                                    },
                                                                }}
                                                            >{capitalizeFirstLetter(questions[currentQuestionIndex].name)}</InputLabel>

                                                            <Select
                                                                label={capitalizeFirstLetter(questions[currentQuestionIndex].name)}
                                                                value={userConfig[questions[currentQuestionIndex].name]}
                                                                onChange={(e) => {
                                                                    updateConfigProperty(questions[currentQuestionIndex].name, e.target.value)
                                                                }}
                                                                sx={{
                                                                    // Default color
                                                                    '& .MuiSelect-select': {
                                                                        color: '#1F2933',
                                                                    },
                                                                    // Color when focused
                                                                    '&.Mui-focused .MuiSelect-select': {
                                                                        color: '#1F2933',
                                                                    },
                                                                    // Arrow color
                                                                    '& .MuiSelect-icon': {
                                                                        color: '#299257',
                                                                    },
                                                                    // Border color when focused
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: '#299257',
                                                                    },
                                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                        borderColor: '#299257',
                                                                    },
                                                                }}
                                                            >
                                                                {
                                                                    questions[currentQuestionIndex].options.map((option) => (
                                                                        <MenuItem value={option.id}>{option.text}</MenuItem>
                                                                    ))
                                                                }

                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    : questions[currentQuestionIndex].type === "number" ?
                                                        (questions[currentQuestionIndex].name == 'height' || questions[currentQuestionIndex].name == 'weight') ? <div>
                                                            <FormControl fullWidth>
                                                                <InputLabel>Unit</InputLabel>
                                                                <Select value={unit} onChange={handleUnitChange} label="Unit"
                                                                    sx={{
                                                                        // Default color
                                                                        '& .MuiSelect-select': {
                                                                            color: '#1F2933',
                                                                        },
                                                                        // Color when focused
                                                                        '&.Mui-focused .MuiSelect-select': {
                                                                            color: '#1F2933',
                                                                        },
                                                                        // Arrow color
                                                                        '& .MuiSelect-icon': {
                                                                            color: '#299257',
                                                                        },
                                                                        // Border color when focused
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#299257',
                                                                        },
                                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#299257',
                                                                        },
                                                                    }}>
                                                                    <MenuItem value="imperial">{capitalizeFirstLetter(questions[currentQuestionIndex].name) == 'Height' ? 'Imperial (ft, in)' : 'Imperial (lbs)'} </MenuItem>
                                                                    <MenuItem value="metric">{capitalizeFirstLetter(questions[currentQuestionIndex].name) == 'Height' ? 'Metric (cm)' : 'Metric (kg)'}</MenuItem>
                                                                </Select>
                                                            </FormControl>

                                                            {unit === 'metric' ? (
                                                                <TextField
                                                                    fullWidth
                                                                    label={capitalizeFirstLetter(questions[currentQuestionIndex].name) == 'Height' ? 'Height (cm)' : 'Weight (kg)'}
                                                                    type="number"
                                                                    value={userConfig[questions[currentQuestionIndex].name]}
                                                                    onChange={
                                                                        (e) => {
                                                                            capitalizeFirstLetter(questions[currentQuestionIndex].name) === 'Height'
                                                                                ? (() => {
                                                                                    // Update the config property
                                                                                    updateConfigProperty(questions[currentQuestionIndex].name, e.target.value);

                                                                                    setFeet(Math.floor(e.target.value / 30.48));
                                                                                    setInches(Math.round(((e.target.value / 30.48) - Math.floor(e.target.value / 30.48)) * 12));
                                                                                })()
                                                                                : (() => {

                                                                                    updateConfigProperty('weight', e.target.value);
                                                                                    updateConfigProperty('p_unit', 'kg');

                                                                                })();
                                                                        }
                                                                    }

                                                                    margin="normal"
                                                                    sx={{
                                                                        '& .MuiInputLabel-root': {
                                                                            color: 'gray',
                                                                            '&.Mui-focused': {
                                                                                color: '#1F2933',
                                                                            },
                                                                        },
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                borderColor: '#82BD9C', // Default border color
                                                                            },
                                                                            '&:hover fieldset': {
                                                                                borderColor: '#299257', // Border color on hover
                                                                            },
                                                                            '&.Mui-focused fieldset': {
                                                                                borderColor: '#299257', // Border color when focused
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            ) : (
                                                                capitalizeFirstLetter(questions[currentQuestionIndex].name) === 'Height' ?
                                                                    // Imperial input (feet and inches)
                                                                    <div style={{ display: 'flex', gap: '16px' }}>
                                                                        <TextField
                                                                            label="Feet"
                                                                            type="number"
                                                                            value={feet}
                                                                            onChange={
                                                                                (e) => {
                                                                                    var newFeet = 0
                                                                                    if (e.target.value >= 0) {
                                                                                        newFeet = e.target.value;

                                                                                    } else {
                                                                                        newFeet = null
                                                                                        e.target.value = null
                                                                                    }
                                                                                    setFeet(newFeet);
                                                                                    updateHeightInCm(newFeet, inches);
                                                                                }}
                                                                            margin="normal"
                                                                            sx={{
                                                                                '& .MuiInputLabel-root': {
                                                                                    color: 'gray',
                                                                                    '&.Mui-focused': {
                                                                                        color: '#1F2933',
                                                                                    },
                                                                                },
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        borderColor: '#82BD9C', // Default border color
                                                                                    },
                                                                                    '&:hover fieldset': {
                                                                                        borderColor: '#299257', // Border color on hover
                                                                                    },
                                                                                    '&.Mui-focused fieldset': {
                                                                                        borderColor: '#299257', // Border color when focused
                                                                                    },
                                                                                },
                                                                            }}
                                                                        />
                                                                        <TextField
                                                                            label="Inches"
                                                                            type="number"
                                                                            value={inches}
                                                                            onChange={
                                                                                (e) => {
                                                                                    var newInches = 0
                                                                                    if (e.target.value >= 0) {
                                                                                        newInches = e.target.value;

                                                                                    } else {
                                                                                        newInches = null
                                                                                        e.target.value = null
                                                                                    }
                                                                                    setInches(newInches);
                                                                                    updateHeightInCm(feet, newInches); // Update the height using feet and inches
                                                                                }}
                                                                            margin="normal"
                                                                            sx={{
                                                                                '& .MuiInputLabel-root': {
                                                                                    color: 'gray',
                                                                                    '&.Mui-focused': {
                                                                                        color: '#1F2933',
                                                                                    },
                                                                                },
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        borderColor: '#82BD9C', // Default border color
                                                                                    },
                                                                                    '&:hover fieldset': {
                                                                                        borderColor: '#299257', // Border color on hover
                                                                                    },
                                                                                    '&.Mui-focused fieldset': {
                                                                                        borderColor: '#299257', // Border color when focused
                                                                                    },
                                                                                },
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    : <TextField
                                                                        fullWidth
                                                                        label="lbs"
                                                                        type="number"
                                                                        value={userConfig[questions[currentQuestionIndex].name]}
                                                                        onChange={((e) => {
                                                                            updateConfigProperty('weight', e.target.value);
                                                                            updateConfigProperty('p_unit', 'lbs');
                                                                        })}
                                                                        margin="normal"
                                                                        sx={{
                                                                            '& .MuiInputLabel-root': {
                                                                                color: 'gray',
                                                                                '&.Mui-focused': {
                                                                                    color: '#1F2933',
                                                                                },
                                                                            },
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    borderColor: '#82BD9C', // Default border color
                                                                                },
                                                                                '&:hover fieldset': {
                                                                                    borderColor: '#299257', // Border color on hover
                                                                                },
                                                                                '&.Mui-focused fieldset': {
                                                                                    borderColor: '#299257', // Border color when focused
                                                                                },
                                                                            },
                                                                        }}
                                                                    />
                                                            )}
                                                        </div>
                                                            : <TextField
                                                                label={userConfig[questions[currentQuestionIndex].name]}
                                                                type="number"
                                                                value={userConfig[questions[currentQuestionIndex].name]}
                                                                onChange={((e) => {
                                                                    updateConfigProperty(questions[currentQuestionIndex].name, e.target.value);
                                                                })}
                                                                margin="normal"
                                                            />
                                                        : null
                                }
                            </div>

                            <div className='flex flex_column gap_40'>
                                {nextButtonStatus ?
                                    <div className='user_config_progress_bar margin_auto'>
                                        <LinearProgress variant="determinate" color='inherit' value={(currentQuestionIndex + 1) * 100 / questions.length} borderRadius={10} sx={{ height: 10, borderRadius: '10px' }} />
                                    </div> : null}


                                <div className='flex align_center justify_center gap_40'>
                                    {currentQuestionIndex != 0 ?
                                        <div>
                                            <BeanButtonPrev onClick={() => { lastQuestion() }} />
                                        </div> : null}

                                    <div>
                                        {(checkNextStatus() == 'next' && !nextButtonStatus) ?
                                            <button onClick={() => { nextQuestion() }} className='user_config_next_button font_size_18 cursor_pointer' >
                                                Complete
                                            </button>
                                            : checkNextStatus() == 'next' ?
                                                <div className='user_config_next_button flex align_center gap_8' onClick={() => { nextQuestion() }}>
                                                    <p className='font_size_18'>Continue</p>

                                                    <GrNext size={18} />
                                                </div>
                                                : checkNextStatus() == 'skip' ?
                                                    <div className='user_config_skip_button flex align_center gap_12' onClick={() => { nextQuestion() }}>
                                                        <p className='font_size_18'>Skip</p>

                                                        <GrNext size={18} />
                                                    </div>
                                                    : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </FullScreenOverlay>
                    )
            }
        </div>

    )
}


export default UserGoals